import React, { useEffect, useState } from "react";
import "./pages.css";
import { Box, Grid, Paper, styled } from "@mui/material";
import Typography from "@mui/material/Typography";
import { TypeAnimation } from "react-type-animation";
import { getQuotes } from "../APIs/Quotes/Queries";
import imag from "../assets/IMG_20210801_193524.jpg";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const welcomeText =
  "Welcome! \nEnjoy reading some Quotes from :\ntype.fit (API)";

function Home() {
  const [quotes, setQuotes] = useState<{ text: string; author: string }[]>();
  const [comp, setComp] = useState(<></>);
  useEffect(() => {
    if (quotes === undefined)
      getQuotes().then((res) => {
        setQuotes(res);
      });
  }, []);
  useEffect(() => {
    if (quotes !== undefined) {
      setComp(
        <TypeAnimation
          sequence={quotes
            ?.map(
              (item: { text: string; author: string }) =>
                `${item?.text} -By ${item.author}`
            )
            .slice(0, 50)}
          speed={10} // Custom Speed from 1-99 - Default Speed: 40
          style={{ fontSize: "2em" }}
          wrapper="span" // Animation will be rendered as a <span>
          repeat={Infinity} // Repeat this Animation Sequence infinitely
        />
      );
    }
  }, [quotes]);


  return (
    <Box sx={{ flexGrow: 1}}>
      <Grid container spacing={2} height="100vh">
        <Grid item xs={12} sx={{ padding: "0% !important" }}>
          <Box
            sx={{
              height: "100vh",
              padding:'10%',
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              flexDirection: "column",
              backgroundImage: `url(${imag})`,
              backgroundRepeat: "no-repeat",
              WebkitBackgroundSize:'cover',
              MozBackgroundSize:'cover',
              backgroundSize:'cover',
              boxShadow:
                "0px 4px 4px 0px #00000040,inset 0 0 0 1000px rgba(0,0,0,.5)",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                textAlign: "start",
                whiteSpace: "pre-line",
                opacity: "80%",
                marginBottom: "5%",
                marginTop: "10%",
                color:'white' 
              }}
            >
              {welcomeText}
            </Typography>
            <Typography
              color="white"
              sx={{ textAlign: "start", fontWeight: "bold" }}
            >
              {comp}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Home;
